<template>
    <TabLayout
        :title="Lang.get('employeedashboard::pages/settings/account.edit.title')"
        :subtitle="Lang.get('employeedashboard::pages/settings/account.edit.subtitle')"
        :tabName="'tabpanel'"
    >

        <div class="row">
            <div class="form-group col-md-4">
                <text-input
                    v-model="account.first_name"
                    :label="Lang.get('employeedashboard::shared.first_name')"
                    :placeholder="Lang.get('employeedashboard::shared.placeholder.first_name')"
                    :disabled="true"
                />
            </div>
            <div class="form-group col-md-4">
                <text-input
                    v-model="account.middle_name"
                    :label="Lang.get('employeedashboard::shared.middle_name')"
                    :placeholder="Lang.get('employeedashboard::shared.placeholder.middle_name')"
                    :disabled="true"
                />
            </div>
            <div class="form-group col-md-4">
                <text-input
                    v-model="account.last_name"
                    :label="Lang.get('employeedashboard::shared.last_name')"
                    :placeholder="Lang.get('employeedashboard::shared.placeholder.last_name')"
                    :disabled="true"
                />
            </div>
            <div class="form-group col-12 col-md-4 col-lg-3 mt-5">
                <inertia-link
                    :href="route('nl.employeedashboard.settings.account.edit', this.$page.props.auth.user.selected_company.uuid)"
                    class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19 px-4">
                    {{ Lang.get('employeedashboard::shared.edit') }}
                </inertia-link>
            </div>
        </div>
    </TabLayout>
</template>

<script>
import TabLayout from "@/Pages/Settings/Shared/TabLayout"
import TextInput from "@/Shared/TextInput";
import FlashMessages from "@/Shared/FlashMessages";


export default {
    metaInfo: {title: Lang.get('employeedashboard::pages/settings/account.view_only.title')},
    components: {
        TextInput,
        TabLayout,
        FlashMessages,
    },
    props: {
        account: Object,
    },
}
</script>
